import { Avatar, useTheme } from '@mui/material'
import useMyProfile from '../../hooks/useMyProfile'
import { useAuthContext } from '../../context/auth'
import { avatarColor, avatarSrc, getInitials } from '../../utils/avatar'

const MyAvatar = ({ size = 36, ...props }) => {
  const theme = useTheme()
  const { auth } = useAuthContext()
  const profile = useMyProfile()
  const name = profile?.name || auth?.name || ''

  return (
    <Avatar
      src={avatarSrc(profile?.avatar)}
      alt={name}
      sx={{ 
        width: size, 
        height: size, 
        ...avatarColor(name, theme.palette.mode),
        cursor: 'pointer' 
      }}
      {...props}
    >
      {getInitials(name)}
    </Avatar>
  )
}

export default MyAvatar